import { render, staticRenderFns } from "./AppAnomaliasCreateOrderDialog.vue?vue&type=template&id=3322a827&scoped=true&"
import script from "./AppAnomaliasCreateOrderDialog.vue?vue&type=script&lang=js&"
export * from "./AppAnomaliasCreateOrderDialog.vue?vue&type=script&lang=js&"
import style0 from "./AppAnomaliasCreateOrderDialog.vue?vue&type=style&index=0&id=3322a827&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3322a827",
  null
  
)

export default component.exports